// assets/pw-zones.js
// Single source of truth for Philip Warren PL/TR local-delivery coverage.
// Loaded as a plain <script> via {{ 'pw-zones.js' | asset_url | script_tag }} — NO ES modules.
//
// ⚠️ COUPLING — the source of truth for whether Home Delivery is offered is the
//    Zapiet | Store Pickup + Delivery app (Zapiet dashboard → Delivery), NOT native
//    Shopify shipping. This list MUST stay identical to the Zapiet Delivery postcode
//    zone. They CANNOT be auto-synced. If delivery coverage ever changes, edit BOTH
//    this file AND the Zapiet delivery postcodes, at the SAME granularity — otherwise
//    you create a "gate says local → Zapiet refuses delivery at /cart" trap.
//    (Click & Collect / pickup is also handled by Zapiet.) Add this to the ops runbook.
//
// matchMode:
//   "area"     → match leading letters only (PL*, TR*). Use if the vans cover ALL of PL and TR.
//   "district" → match the full outward code (PL1, PL2, TR1, …). Use if coverage is partial;
//                then enumerate every served district in 'prefixes'.
//
// NOTE: PL covers Plymouth and parts of Devon, not just Cornwall — confirm that's in van range.
window.PW_ZONES = {
  prefixes: ["PL", "TR"],
  matchMode: "area"
};
